<template>
  <div>
    <Edit
      :item="currentItem"
      :close="closeEdit"
      :submit="submit"
      :update="update"
      :mershandisings="mershandisings"
    ></Edit>
    <History
      :item="currentItem"
      :close="closeHistory"      
    ></History>
    <div
      class="filters row"
      style="margin-top:0;     justify-content: flex-end;"
    >
      <div class="col-1-12">
        <div class="pull-right">
          <button
            v-on:click="openCreate"
            class="button button-success button-block"
          >
            <fa-icon icon="plus" /> Novo Estoque
          </button>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>Id</th>
            <th>Mershandising</th>
            <th>Quantidade</th>
            <th>Reservado</th>
            <th>Disponível</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" v-bind:key="item.id">
            <td class="highlight">{{ item.id }}</td>
            <td v-if="item.mershandising">
              {{ item.mershandising_id }} - {{ item.mershandising.descricao }}
            </td>
            <td v-else>
              {{ item.mershandising_id }} - Sem descrição
            </td>
            <td>{{ item.quantidade }}</td>
            <td>{{ item.reservado }}</td>
            <td>{{ item.disponivel }}</td>
            <td class="actions">              
              <button
                type="button"
                class="button button-light"
                v-on:click="openHistory(item)"
              >
                <fa-icon icon="clock" />
              </button>
              &nbsp;
              <button
                type="button"
                class="button button-primary"
                v-on:click="openEdit(item)"
              >
                <fa-icon icon="pencil-alt" />
              </button>
              &nbsp;
              <button
                type="button"
                name="button"
                v-on:click="remove(item.id)"
                class="button button-error"
              >
                <fa-icon icon="trash-alt" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import clone from "just-clone";

import { get, post, put, del } from "../../../../helpers/apiRequest";
import Edit from "./Edit";
import History from "./History";

export default {
  name: "mershandising-list",
  components: {
    Edit,
    History
  },
  props: ["mershandisings"],
  data() {
    return {
      descPlural: "",
      loading: false,
      items: [],
      currentItem: {},
      table: {
        filter: "",
        columns: [
          { label: "ID", field: "id", align: "center", sortable: false },
          {
            label: "Mershandising ID",
            field: "mershandising_id",
            align: "center",
            sortable: false,
          },
          { label: "Quantidade", field: "quantidade", sortable: false },
        ],
      },
    };
  },
  computed: {},
  methods: {
    loadEstoque() {
      get(`/admin/mershandising/estoque`)
        .then((json) => {
          this.items = json.itens;
          this.table.paginator = json.paginator;
          this.loading = false;
        })
        .catch((err) => (this.loading = false));
    },
    openCreate() {
      this.openEdit({
        mershandising_id: null,
        quantidade: null,
      });
    },
    closeCreate() {
      this.$modal.hide("mEdit");
    },
    openEdit(item) {
      this.currentItem = clone(item);
      this.$modal.show("mEdit");
    },
    closeEdit() {
      this.$modal.hide("mEdit");
    },
    submit(item) {
      post("/admin/mershandising/estoque/save", item)
        .then((json) => {
          this.$modal.hide("mEdit");
          this.loadEstoque();
          this.$swal({
            title: 'Salvo com sucesso',
            text: json.message,
            showCancelButton: false,
            cancelButtonText: 'Fechar',
            showConfirmButton: true,
            icon: 'success',
          });           
        })
        .catch((error) => {
          this.loading = false;
          this.$swal({
            title: "Ops!",
            text: error.message,
            icon: "error",
          });
        });
    },
    update(item) {
      put(`/admin/mershandising/estoque/update/${item.id}`, item)
        .then((json) => {
          this.$modal.hide("mEdit");
          this.loadEstoque();
          this.$swal({
            title: 'Salvo com sucesso',
            text: json.message,
            showCancelButton: false,
            cancelButtonText: 'Fechar',
            showConfirmButton: true,
            icon: 'success',
          });          
        })
        .catch((error) => {
          this.loading = false;
          this.$swal({
            title: "Ops!",
            text: error.message,
            icon: "error",
          });
        });
    },
    remove(id) {
      this.$swal({
        title: "Confirma Remover?",
        text: "Essa ação não poderá ser desfeita",
        showCancelButton: true,
        icon: "warning",
        confirmButtonText: "Excluir",
        cancelButtonText: "Cancelar",
      })
        .then((res) => {
          if (res.value) {
            this.loading = true;
            del(`/admin/mershandising/estoque/delete/${id}`)
              .then((json) => {
                this.loading = false;
                this.loadEstoque();
                this.$swal({
                  title: 'Removido com sucesso',
                  text: json.message,
                  showCancelButton: false,
                  cancelButtonText: 'Fechar',
                  showConfirmButton: true,
                  icon: 'success',
                });  
              })
              .catch((error) => {
                this.loading = false;
                this.$swal({
                  title: "Ops!",
                  text: error.message,
                  icon: "error",
                });
              });
          }
        })
        .catch(() => {});
    },
    openHistory(item) {      
      this.currentItem = clone(item);
      this.$modal.show("mHistory");
    },
    closeHistory() {
      this.$modal.hide("mHistory");
    },
  },
  beforeMount() {
    this.loading = true;
    this.loadEstoque();
  },
};
</script>
